import {
  useLazyGetPaymentMethodsQuery,
  useGetPaymentMethodsQueryState,
} from './payment.api';
import {
  setPaymentMethod,
  setIsInChallenge,
  setAttemptsCount as sAC,
} from './payment.slice';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { skipToken } from '@reduxjs/toolkit/query';

export default function usePayment() {
  const dispatch = useDispatch();
  const {
    event: { id },
  } = useSelector((state) => state.event || { event: {} }, shallowEqual);
  const { method, isInChallenge, attemptsCount } = useSelector(
    (state) => state.payment,
    shallowEqual,
  );
  const { isLoading, data } = useGetPaymentMethodsQueryState(id || skipToken);
  const [trigger] = useLazyGetPaymentMethodsQuery();

  const setBookingPayment = (payment) => {
    dispatch(setPaymentMethod(payment));
  };

  const changeIsInChallengeStatus = (status) => {
    dispatch(setIsInChallenge(status));
  };

  const setAttemptsCount = () => {
    dispatch(sAC(attemptsCount + 1));
  };

  const resetBookingPayment = () => {
    dispatch(
      setPaymentMethod({
        'Gateway::Banwire': {
          creditCard: false,
          valid: false,
        },
      }),
    );
  };

  const loadPaymentMethods = async () => {
    await trigger(id);
  };

  return {
    payment: method,
    isInChallenge,
    attemptsCount,
    isLoading,
    paymentMethods: data || [],
    setBookingPayment,
    setAttemptsCount,
    changeIsInChallengeStatus,
    resetBookingPayment,
    loadPaymentMethods,
  };
}
